import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Modules } from "../../utils/modules";

const initialState: Modules = {};

const modulesSlice = createSlice({
  name: "overrideModules",
  initialState,
  reducers: {
    setOverrideModule: (state, action: PayloadAction<{ orgId: string; module: string }>) => {
      const orgId = action.payload.orgId;
      state[orgId] = state[orgId] ?? [];
      state[orgId].push({ name: action.payload.module });
    },
    unsetOverrideModule: (state, action: PayloadAction<{ orgId: string; module: string }>) => {
      const orgId = action.payload.orgId;
      state[orgId] = state[orgId] ?? [];
      state[orgId] = state[orgId].filter((m) => m.name.toLowerCase() !== action.payload.module.toLowerCase());
    },
  },
});

export const { setOverrideModule, unsetOverrideModule } = modulesSlice.actions;
export default modulesSlice.reducer;
